import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultType } from '../../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../../services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';

@Component({
    selector: 'app-matrix-remove',
    templateUrl: './matrix-remove.component.html',
    styleUrls: ['./matrix-remove.component.scss'],
    standalone: false
})
export class MatrixRemoveComponent implements OnInit {
    @Input() userMatrixId: string;
    @Output() refreshMatrix: EventEmitter<boolean> = new EventEmitter();

    tooltip_position = 'above';
    closeResult: string;
    result: ResultType = ResultType.Error;
    isMatrixDelete: boolean;

    constructor(
        private modalService: NgbModal,
        private mgmtApi: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityService: UserUtilityService
    ) {
        this.isMatrixDelete = false;
    }

    async ngOnInit(): Promise<void> {
        // * checking access level
        this.isMatrixDelete = await this.userUtilityService.checkUserPermissionDataAndRoute('matrix', userActions.Delete);
    }

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                windowClass: 'my_modal_class',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    btnDeleteMatrix() {
        this.removeMatrix();
        this.modalService.dismissAll();
    }

    async removeMatrix() {
        this.ngxUiLoaderService.start();
        let result = await this.mgmtApi
            .removeMatrix(this.userMatrixId)
            .toPromise()
            .then(
                (res) => {
                    this.ngxUiLoaderService.stop();
                    if (res.success === true) {
                        return res.response;
                    } else {
                        this.userUtilityService.errorModelPopup(res.message);
                    }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );
        // this.customToastService.genericToast(this.result);
        this.refreshMatrix.emit(true);
    }
}
